import React, { useState, useEffect,useRef } from "react";
import VideoRecorder from "react-video-recorder";
import logo from "../assets/images/logo.png";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Axios from "axios";
import { GetJobRoles, HRinitialScreening, PostAttemptedQuestions, TestSaveCandidateRecordedVideo,GetInterviewDetailWithOutQuns,  UpdateInterviewCandidateByID_Rating, GenerateContent, transcribe, AddCodingIntQuns } from "../apiconstants/constants";
import LoadingSpinner from "../helpers/loadingspinner";
import parse from 'html-react-parser';
import DOMPurify from "dompurify";
import { Editor } from "@monaco-editor/react";
import NoMobileAccess from "../nomobileaccess";
import ailogo from "../assets/images/ai.jpg"
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import alertimg from  "../assets/images/aitestalert.png"

const Assessment = () => {
  const [recordedVideoUrl, setRecordedVideoUrl] = useState(null);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [recordingStopped, setRecordingStopped] = useState(false);
  const [startTime, setStartTime] = useState(null); 
  const [timerId, setTimerId] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(); 
  const [data, setData] = useState({});
  const [questionsData, setQuestionsData] = useState({});
  const [jobRoleId, setJobRoleId] = useState();
  const [showScreen, setShowScreen] = useState(false);
  const [showInstructions, setShowInstructions] = useState(true); 
  const search = useLocation().search;
  const [jobRoles, setJobRoles] = useState([]);
  const [isActive, setisActive] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [showThankYouMessage, setShowThankYouMessage] = useState(false); 
  const [isRecordingInProgress, setIsRecordingInProgress] = useState(false); 
  const [showWaitMessage, setShowWaitMessage] = useState(false);
  const [endDateMessage, setEndDateMessage] = useState(false);
  const [startDateMessage, setStartDateMessage] = useState(false);
  const [visibilityChangeCount, setVisibilityChangeCount] = useState(0);
  const GuiId = new URLSearchParams(search).get("GuiId");
  const [cameraStarted, setCameraStarted] = useState(false);
  const [MAX_RECORDING_TIME, setMaxRecordingTime] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [recording, setRecording] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const mediaRecorderRef = useRef(null);
  const recordedChunksRef = useRef([]);
  const screenStreamRef = useRef(null);
  const webcamStreamRef = useRef(null);
  const webcamVideoRef = useRef(null);
  const audioStreamRef = useRef(null);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [candidateResponses, setCandidateResponses] = useState([]);
  const [isListening, setIsListening] = useState(false);
  const [recognition, setRecognition] = useState(null);
  const [tempAnswer, setTempAnswer] = useState(""); // Temporary answer storage
  const [score, setScore] = useState(null);
  const [interviewComplete, setInterviewComplete] = useState(false);
  const [evaluationResponse, setEvaluationResponse] = useState(null); // Holds full response
  const [isOpen, setIsOpen] = useState(true);  // Initially open the first accordion item
  const [isChecked, setIsChecked] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const candidateResponsesRef = useRef([]);
  const questionsRef = useRef([]);
const latestTranscriptRef = useRef(""); // holds last spoken words in real-time
const [isFinalAnswerCaptured, setIsFinalAnswerCaptured] = useState(false);
  const [submitAiQuestions, setSubmitAiQuestions] = useState(false);
const currentQuestionIndexRef = useRef(0);
const audioRecorderRef = useRef(null);
const audioChunksRef = useRef([]);
useEffect(() => {
  currentQuestionIndexRef.current = currentQuestionIndex;
}, [currentQuestionIndex]);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const validateGuiId = async () => {
    try {
      const GetapiUrl = `${GetInterviewDetailWithOutQuns.APIURL}/${GuiId}`;
      const response = await Axios.get(GetapiUrl);
      setData(response.data[0]);
      setisActive(response.data[0].isActive);
      const jobRoleid = response.data[0].jobRoleID
      localStorage.setItem('jwtToken', response.data[0].jwtToken)

      setJobRoleId(jobRoleId);
      const startDate = (response.data[0].startDate);
      const endDate = (response.data[0].endDate);
      setMaxRecordingTime(response.data[0].time * 60 * 1000)
      setTimeRemaining(response.data[0].time * 60 * 1000)
      const currentDate = new Date();
      const parsedStartDate = new Date(startDate);
      parsedStartDate.setHours(0, 0, 0, 0); // Set to beginning of day
      const parsedEndDate = new Date(endDate);
      parsedEndDate.setHours(23, 59, 59, 999); // Set to end of day

      if (currentDate < parsedStartDate) {
        console.log("Before start date");
        setStartDateMessage(true);
        setShowScreen(false);
      } else if (currentDate > parsedEndDate) {
        setEndDateMessage(true);
        setShowScreen(false);
      } else {
        setShowScreen(true);
      }

    } catch (error) {
      console.error("Error: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during validation",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      setIsLoading(false); 
    }
  };


  useEffect(() => {
    validateGuiId();
  }, []);


  // useEffect(() => {
  //   if (!data) return; // Wait until data is available

   
  //   fetchQuestions();
  // }, [data]); 
  const fetchQuestions = async () => { 
    const token = localStorage.getItem('jwtToken');
    try {
      const plainTextJD = data.jobDescription.replace(/<\/?[^>]+(>|$)/g, ""); // Remove HTML tags
      const response = await Axios.post(GenerateContent.APIURL, {
        
              prompt: `Generate exactly ${data.questionsCount} unique and concise interview questions based on this Job Description: ${plainTextJD}. 
                     Each question should be on a new line and should be numbered (1-4). 
                     Do not include any introduction, explanations, or answers—only the questions.` 
        
      },
      { headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Authorization': `Bearer ${token}` // Add the Authorization header       
         }}

    );
  
      const textResponse = response.data?.response?.candidates[0].content.parts[0].text;
  
      // Extract only the numbered questions (1-5)
      const questionsArray = textResponse
        .split("\n")
        .map(q => q.trim()) // Remove extra spaces
        .filter(q => /^\d+\./.test(q)) // Keep only lines that start with "1.", "2.", etc.
        .map(q => q.replace(/^\d+\.\s*/, "")); // Remove the numbering (if needed)
  
      setQuestions(questionsArray); // Ensure only 5 questions
      questionsRef.current = questionsArray;    
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };
const startAudioRecording = async () => {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const mediaRecorder = new MediaRecorder(stream);
  audioRecorderRef.current = mediaRecorder;
  audioChunksRef.current = [];

  mediaRecorder.ondataavailable = (e) => {
    if (e.data.size > 0) {
      audioChunksRef.current.push(e.data);
    }
  };

  mediaRecorder.start();
};
const stopAudioRecordingAndSend = (index) => {
  console.log(`🎤 Transcribing answer for question ${index + 1}`);

  const recorder = audioRecorderRef.current;
  if (!recorder) return;

  recorder.onstop = async () => {
    const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
let text = "No Answer"; 
    try {
      const formData = new FormData();
      formData.append("file", audioBlob, `question-${index}.webm`);

      const response = await Axios.post(transcribe.APIURL, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

       text = response.data?.text?.trim() || "No Answer";

      // Save response when it arrives
      setCandidateResponses((prev) => {
        const updated = [...prev];
        updated[index] = text;
        candidateResponsesRef.current = updated;
  console.log("📌 Saved final answer:", text, "at index:", index);
        return updated;
      });
    } catch (err) {
      console.error("Transcription failed for question", index);
    }
  };

  recorder.stop();
  audioRecorderRef.current = null;
  audioChunksRef.current = [];
};


useEffect(() => {
  if (showQuestions && !interviewComplete) {
    startAudioRecording();
  }
}, [currentQuestionIndex, showQuestions]);

const listeningTimerRef = useRef(null);

const handleNextQuestion = async () => {
  const index = currentQuestionIndex;

  // Stop and wait for transcription to finish first
  // await stopAudioRecordingAndSend(index);

  // Then move to next question
  const nextIndex = index + 1;
  setCurrentQuestionIndex(nextIndex);

  // Slight delay to allow DOM/UI render before recording again
  // setTimeout(() => {
  //   startAudioRecording();
  // }, 300);
};



  const evaluateCandidate = async (candidateResponses,questions) => { 
    console.log("candidateResponses",candidateResponses,questions)
    const token = localStorage.getItem('jwtToken');
    try {
      let evaluationPrompt = `[  
        Evaluate the candidate's responses and provide a structured output for each question:  
        - **CandidateResponse**: Include the exact response given by the candidate.  
        - **AIEvaluationResponse**: Provide detailed comments on the strengths and weaknesses of the candidate's answer.  
        - **Score**: Assign a score out of 5 based on the quality, depth, and accuracy of the response.  
      
        Candidate's Responses:  
      `;
      
      questions.forEach((q, index) => {
        evaluationPrompt += `Q${index + 1}: ${q}\nA: ${candidateResponses[index] || "No Answer"}\n`;
      });
      
      evaluationPrompt += `  
      
      ### Return Format:  
      Return the result as a *JSON array* where each object contains:  
      - *question* – The question text.  
      - *CandidateResponse* – The exact response given by the candidate.  
      - *AIEvaluationResponse* – Detailed evaluation comments.  
      - *Score* – Numeric score out of 0-5.  
      
      Example:  
      [  
        {  
          "question": "What is your experience with React?",  
          "CandidateResponse": "I have been working with React for 3 years and have built multiple projects.",  
          "AIEvaluationResponse": "The candidate has a solid understanding of React but could improve on state management techniques.",  
          "Score": "4"  
        },  
        {  
          "question": "How do you handle state in React?",  
          "CandidateResponse": "I use useState and useReducer.",  
          "AIEvaluationResponse": "The candidate mentioned using useState and useReducer, but lacked depth on context handling.",  
          "Score": "3"  
        }  
      ]  
      `;
            
      // Send request to Gemini
      const response = await Axios.post(GenerateContent.APIURL,
        { prompt: evaluationPrompt 
      },
      { headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Authorization': `Bearer ${token}` // Add the Authorization header       
         }}
      );
  
      let fullResponse = response.data.response?.candidates[0].content.parts[0].text;
  
      console.log("Full Response:", fullResponse);
     const Response = fullResponse.replace(/```json|```/g, '').trim();
     console.log("replaced Response:", Response);

let parsedResponse;
let finalScore = 0;

try {
  parsedResponse = JSON.parse(Response);

  const totalScoreFromAI = parsedResponse.reduce((acc, item) => acc + Number(item.Score), 0);
  const totalQuestions = questions.length;
  finalScore = Math.round(totalScoreFromAI / totalQuestions);

  // Always send structured JSON
  await submitRatingandComments(JSON.stringify(parsedResponse), finalScore);
} catch (err) {
  console.warn("Parsing failed, using raw response instead.");
  
  // Fallback: store full text as-is, set score to 0
  await submitRatingandComments(JSON.stringify(Response), 0);
}

} catch (error) {
console.error("Error evaluating candidate:", error);
}
};
  
  // // Effect to check when score and response are both set, then call stopRecording
  // useEffect(() => {
  //   if (score != null && evaluationResponse != null) {
  //     setTimeout(() => {
  //       stopRecording();
  //     }, 7000);
  //   }
  // }, [score && evaluationResponse]);

  const handleVisibilityChange = () => {
    if (!recordingStopped && !showThankYouMessage) {
      setVisibilityChangeCount(prevCount => prevCount + 1);
      if (visibilityChangeCount === 1) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recording will be stopped when you change tab/window. Please do not switch tabs.",
          showConfirmButton: false,
          timer: 5000,
        });
      } else if (visibilityChangeCount === 2) {
        stopRecordingWithDelay();
    
      }
    }
  };
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const stopRecordingWithDelay = () => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "You switched tabs again. Recording is now stopping and submitting video.",
      showConfirmButton: false,
      timer: 5000,
    }).then(() => {
      setShowWaitMessage(true);
      setTimeout(() => {
        stopRecording();
      }, 3000); // 3 seconds delay
    });
  };
  

  useEffect(() => {
    if (isRecordingInProgress && !recordingStopped) {
      document.addEventListener("visibilitychange", handleVisibilityChange);
    } else {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    }

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isRecordingInProgress, recordingStopped,visibilityChangeCount]);

  useEffect(() => {
    if (startTime && !recordingStopped) {
      const interval = setInterval(() => {
        const elapsedTime = Date.now() - startTime;
        setTimeRemaining(MAX_RECORDING_TIME - elapsedTime);
        if (elapsedTime >= MAX_RECORDING_TIME) {
          stopRecording();
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [startTime, recordingStopped]);

  const handleCameraOn =async () => {
    setCameraStarted(true);
     try {
      const GetapiUrl = `${HRinitialScreening.APIURL}/${GuiId}`;
      const response = await Axios.get(GetapiUrl);
     setQuestionsData(response.data[0].questions);
      if(response.data[0].isCustomQuestionsRequired){
        console.log("413true",typeof response.data[0].isCustomQuestionsRequired )
        const questionsData = response.data[0].questions?.map((x)=>x.questionName)
        setQuestions(questionsData);
        questionsRef.current = questionsData;   
        setSubmitAiQuestions(true); 
       } 
       
       else{
        await fetchQuestions();
       }
    } catch (error) {
      console.error("Error: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during validation",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      setIsLoading(false); 
    }

    setIsRecordingInProgress(true);
  };

  const startRecording =async () => {

    const id = setTimeout(() => {
      startRecording();
    }, MAX_RECORDING_TIME);
    setTimerId(id);
  
  };

  const startTest = async () => { 
    if (!isChecked) {
        Swal.fire({
        position: "center",
        icon: "warning",
        title: "Please accept the terms and conditions to start the test!",
        showConfirmButton: false,
        timer: 4000,
      });
      return;
    }
  
    try {
      let isVideoRequired = data.isVideoRequired;
  
      // Get screen recording stream (with system audio)
      const screenStream = await navigator.mediaDevices.getDisplayMedia({
        video: {
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          frameRate: { ideal: 30 },
        },
        audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }   
      });

      // Validate full-screen selection
      const videoTrack = screenStream.getVideoTracks()[0];
      const settings = videoTrack.getSettings();
      if (settings.displaySurface && settings.displaySurface !== "monitor") {
        alert("Please select the entire screen, not a window or tab.");
        screenStream.getTracks().forEach((track) => track.stop());
        return;
      }

      await handleCameraOn();
      setShowVideo(true);
      let webcamStream = null;

      // Get microphone audio (always)
      const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const micAudioTrack = audioStream.getAudioTracks()[0];
  

  
      // If isVideoRecording is true, get webcam and microphone stream
      if (isVideoRequired) {
        webcamStream = await navigator.mediaDevices.getUserMedia({
          video: { width: 320, height: 240 },
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
        });
  
        // Display webcam preview
        webcamVideoRef.current.srcObject = webcamStream;
        webcamVideoRef.current.play();
      }
  
      // Store screen stream
      screenStreamRef.current = screenStream;
      if (isVideoRequired) {
        webcamStreamRef.current = webcamStream;
      }
  
      // Extract screen audio
      const screenAudioTrack = screenStream.getAudioTracks().find(track => track.kind === "audio");
        if (screenAudioTrack && micAudioTrack) {
        await Swal.fire({
          position: "center",
          title: "Please Do not turn on the system audio",
          showConfirmButton: false,
          timer: 10000,
        imageUrl: alertimg,
        imageWidth: 200,
        imageHeight: 200,
        imageAlt: "Audio warning",
        });
        window.location.reload();
        return;
      }
      // Combine video and audio streams
      const combinedStream = new MediaStream([
        ...screenStream.getVideoTracks(), // Always record screen video
        ...(isVideoRequired && webcamStream ? webcamStream.getVideoTracks() : []), // Webcam video if enabled
        ...(screenAudioTrack ? [screenAudioTrack] : []), // System audio (if available)
        ...(micAudioTrack ? [micAudioTrack] : []), // Microphone audio (if available)
      ]);
  
      // Start recording
      recordedChunksRef.current = [];
      mediaRecorderRef.current = new MediaRecorder(combinedStream, {
        mimeType: "video/webm",
      });

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) recordedChunksRef.current.push(event.data);
      };

      mediaRecorderRef.current.start();
      startRecording();
      setStartTime(Date.now());
      setRecording(true);
      setShowInstructions(false);
      setShowQuestions(true);
      setIsExpanded(true);
      // Stop recording when screen sharing ends
      screenStream.getVideoTracks()[0].onended = stopRecording;
    } catch (error) {
      alert("Screen recording failed. Please allow full-screen recording.");
    }
};

// useEffect(() => {
//   if (showQuestions && !interviewComplete && questions.length > 0) {
//     latestTranscriptRef.current = "";
//     setTempAnswer("");
//     setIsFinalAnswerCaptured(false); // ✅ reset flag
//     startListening();
//   }
// }, [currentQuestionIndex, showQuestions]);

// const stopRecording = async () => {
// const lastIndex = currentQuestionIndexRef.current;
//   // Stop last audio recording and transcribe
//   let text = "No Answer"; 
//   if (audioRecorderRef.current && audioRecorderRef.current.state !== "inactive") {
//     await new Promise((resolve) => {
//       audioRecorderRef.current.onstop = async () => {
//         const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });

//         try {
//           const formData = new FormData();
//           formData.append("file", audioBlob, `question-${lastIndex}.webm`);
// console.log("📝 Saving last Q", lastIndex + 1, "->", text);

//           const response = await Axios.post(transcribe.APIURL, formData, {
//             headers: { "Content-Type": "multipart/form-data" },
//           });

//           text = response.data?.text?.trim() || "No Answer";
//           console.log("✅ Final transcript for Q", lastIndex + 1, ":", text);

//           // Save final response
//           setCandidateResponses((prev) => {
//             const updated = [...prev];
//             updated[lastIndex] = text;
//             candidateResponsesRef.current = updated;
//               console.log("✅ Final Candidate Responses (after last question):", updated);
//             return updated;
//           });

//         } catch (err) {
//           console.error("Transcription failed on submit:", err);
//         }

//         audioRecorderRef.current = null;
//         audioChunksRef.current = [];
//         resolve();
//       };

//       audioRecorderRef.current.stop();
//     });
//   }

//   // -- STOP MEDIA RECORDING --
//   if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
//     mediaRecorderRef.current.stop();
//   }

//   // Stop all media streams
//   if (screenStreamRef.current) {
//     screenStreamRef.current.getTracks().forEach(track => track.stop());
//     screenStreamRef.current = null;
//   }

//   if (webcamStreamRef.current) {
//     webcamStreamRef.current.getTracks().forEach(track => track.stop());
//     webcamStreamRef.current = null;
//   }

//   if (audioStreamRef.current) {
//     audioStreamRef.current.getTracks().forEach(track => track.stop());
//     audioStreamRef.current = null;
//   }

//   // When media recorder stops, upload video
//   mediaRecorderRef.current.onstop = async () => {
//     const blob = new Blob(recordedChunksRef.current, { type: "video/webm" });
//     setVideoUrl(URL.createObjectURL(blob));
//     setRecordedVideoUrl(blob);

//    await handleRecordingComplete(blob, candidateResponsesRef.current);
//   };

//   // Clear
//   recordedChunksRef.current = [];
//   // DO NOT nullify mediaRecorderRef yet — it’s still used in `onstop`

//   // Update state
//   setRecording(false);
//   setRecordingStopped(true);
//   setIsRecordingInProgress(false);

//   // Just in case any media was left open
//   navigator.mediaDevices.getUserMedia({ audio: true, video: true })
//     .then(stream => stream.getTracks().forEach(track => track.stop()))
//     .catch(err => console.error("Error cleaning up media:", err));
// };
const stopRecording = async () => {
   const lastIndex = currentQuestionIndexRef.current;

  // let finalTranscript = "No Answer";

  // if (audioRecorderRef.current && audioRecorderRef.current.state !== "inactive") {
  //   finalTranscript = await new Promise((resolve) => {
  //     audioRecorderRef.current.onstop = async () => {
  //       const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });

  //       try {
  //         const formData = new FormData();
  //         formData.append("file", audioBlob, `question-${lastIndex}.webm`);

  //         const response = await Axios.post(transcribe.APIURL, formData, {
  //           headers: { "Content-Type": "multipart/form-data" },
  //         });

  //         const text = response.data?.text?.trim() || "No Answer";
  //         console.log("✅ Final transcript for Q", lastIndex + 1, ":", text);
  //         resolve(text);
  //       } catch (err) {
  //         console.error("Transcription failed on submit:", err);
  //         resolve("No Answer");
  //       }

  //       audioRecorderRef.current = null;
  //       audioChunksRef.current = [];
  //     };

  //     audioRecorderRef.current.stop();
  //   });

  //   // ✅ Force update the candidateResponsesRef immediately (not relying on async setState)
  //   candidateResponsesRef.current[lastIndex] = finalTranscript;
  //   setCandidateResponses([...candidateResponsesRef.current]);
  // }

  // -- STOP MEDIA RECORDING --
  if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
    mediaRecorderRef.current.onstop = async () => {
      const blob = new Blob(recordedChunksRef.current, { type: "video/webm" });
      setVideoUrl(URL.createObjectURL(blob));
      setRecordedVideoUrl(blob);

      // ✅ Now candidateResponsesRef is guaranteed to have the latest answer
      await handleRecordingComplete(blob, candidateResponsesRef.current);
    };

    mediaRecorderRef.current.stop();
  }

  // Cleanup
  if (screenStreamRef.current) {
    screenStreamRef.current.getTracks().forEach(track => track.stop());
    screenStreamRef.current = null;
  }
  if (webcamStreamRef.current) {
    webcamStreamRef.current.getTracks().forEach(track => track.stop());
    webcamStreamRef.current = null;
  }
  if (audioStreamRef.current) {
    audioStreamRef.current.getTracks().forEach(track => track.stop());
    audioStreamRef.current = null;
  }

  recordedChunksRef.current = [];
  setRecording(false);
  setRecordingStopped(true);
  setIsRecordingInProgress(false);

  navigator.mediaDevices.getUserMedia({ audio: true, video: true })
    .then(stream => stream.getTracks().forEach(track => track.stop()))
    .catch(err => console.error("Error cleaning up media:", err));
};


  
   const submitQuestions = async () => {
    try {
      const params = {
        guid: GuiId,
        questions: questionsData,
        jobRoleId: data?.jobRoleID,
      };

      await Axios.post(PostAttemptedQuestions.APIURL, params);
    } catch (error) {
      console.error("Error submitting questions: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during questions submission",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  const AddAIQuestions = async () => {
    try {
      const params = {
        guiID: GuiId,
        codingIntQuns: JSON.stringify(questionsRef.current),
        "testTypeID": 5,
      };

      await Axios.post(AddCodingIntQuns.APIURL, params);
    } catch (error) {
      console.error("Error submitting questions: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during questions submission",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  const handleRecordingComplete = async (videoBlob,responses) => {
    console.log("videoBlob",videoBlob)
    console.log("Video Size:", videoBlob.size, "bytes");
     const videoUrl = URL.createObjectURL(videoBlob);
    //setRecordedVideoUrl(videoBlob);
    setShowWaitMessage(true);
    setIsLoading(false);

    setRecordingStopped(true);
    setIsRecordingInProgress(false);
    clearTimeout(timerId);
    setTimeout(async () => {
      setShowWaitMessage(false); 
      setIsLoading(true); 

      try {
        const formData = new FormData();
        formData.append("guid", GuiId);
        formData.append("CandidateName", data?.name);
        formData.append("videoUrl", URL.createObjectURL(videoBlob));
        formData.append("video", videoBlob, "recording.webm");
        console.log("formData",formData)
        const response = await Axios.post(
          TestSaveCandidateRecordedVideo.APIURL,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        // if (response.status === 200) {
          if (response.data == 'Video uploaded successfully') {

       if(submitAiQuestions == true){
        console.log("808")
              await submitQuestions();
            }
            else{
          await  AddAIQuestions(); 
            }
         // await  submitQuestions();
       //  await evaluateCandidate(responses, questionsRef.current);
          setIsLoading(false);

          Swal.fire({
            position: "center",
            icon: "success",
            title: "screen recording is submitted",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            setShowThankYouMessage(true); // Show thank you message after success alert
          });
          // window.location.reload();
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Failed to upload video",
            showConfirmButton: false,
            timer: 2000,
          });
        }
        setIsLoading(false);

      } catch (error) {
        console.error("Error uploading video: " + error);
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "An error occurred during screen recording upload",
          showConfirmButton: false,
          timer: 5000,
        });
        setIsLoading(false);
      }
    }, 4000); // Delay of 5 seconds
  };
   
     const submitRatingandComments = async (evaluationResponse,score) => {
        const params = {
              guiID: GuiId,
              comment: evaluationResponse,
              rating: score.toString()
          };
          const apiUrl = UpdateInterviewCandidateByID_Rating.APIURL;
          try {
              await Axios.post(apiUrl, params);
            
          } catch (error) {
            console.error("Error submitting rating: " + error);
            Swal.fire({
              position: "center",
              icon: "error",
              title: "An error occurred during rating submission",
              showConfirmButton: false,
              timer: 2000,
            });
          }
      };
  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  if (isLoading) {
    return (
      <center>
        <LoadingSpinner />
      </center>

    );
  }

  if (showWaitMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Please don't close the window until you are notified that your screen recording has been successfully saved. </h3>
        </div>
      </div>

    )
  }

  if (startDateMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Please wait untill Interview.Reach out to <b style={{ color: "#00a7ac" }}>hire@knackhook.com</b> if you have any questions.</h3>
        </div>
      </div>

    )
  }
  if (endDateMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Link has Expired.Please reach out to <b style={{ color: "#00a7ac" }}>hire@knackhook.com</b> if you have any questions.</h3>
        </div>
      </div>

    )
  }

  return (
  <NoMobileAccess>
       {showScreen && isActive ? (
         <div style={{ flexDirection: "row" }}>
           {recordingStopped ? (
             showThankYouMessage ? (
               <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                 <div className="container" style={{ textAlign: "center" }}>
                   <h4>Thank you for attending the interview, please reach out to <b style={{ color: "#00a7ac" }}>hire@knackhook.com</b> if you have any questions. Now you can close the browser window.</h4>
                 </div>
               </div>
             ) : (
               <></>
             )
           ) : (
             <div className="container mt-2 pb-5">
    <div className="card shadow-lg p-4" style={{ border: "none" }}>
    
     <div className="row">
      {/*
     <div  className={`col-sm-12 col-lg-${isExpanded ? 12 : 6} col-xl-${isExpanded ? 12 : 6} col-md-${isExpanded ? 12 : 6}`}>*/}
   {/* col-6  */}
   <div className={`col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isExpanded ? 'd-none' : ''}`}>
       
           {/* User Information Card */}
           <div className="card shadow-lg p-3 text-center" style={{border: 'none', backgroundColor: '#00a7ac', color: '#fff'}}>
             <p className="text-para" style={{fontSize: 15}}>Name: <b>{data.name}</b></p>
             <p className="text-para" style={{fontSize: 15}}>Email: <b>{data.email}</b></p>
             <p className="text-para">Technology: <b>{data?.technology}</b></p>
             <p className="text-para" style={{fontSize: 15}}>Time : <b>{formatTime(timeRemaining)}</b></p>
           </div>
 
           {/* Accordion for Instructions */}
           <div className="accordion mt-3 shadow-lg" id="accordionExample">
             <div className="accordion-item">
               <h2 className="accordion-header" id="headingThree">
                 <button
                   className="accordion-button"
                   type="button"
                   onClick={toggleAccordion} // Toggles the collapse on button click
                   aria-expanded={isOpen ? "true" : "false"} // Dynamically update the expanded state
                   aria-controls="collapseThree"
                   style={{ fontWeight: 'bold', paddingRight: '30px', backgroundColor: '#fff', color: '#00a7ac' }}
                 >
                   Online Assessment Instructions and Consent
                 </button>
               </h2>
               <div
                 id="collapseThree"
                 className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`} // Add 'show' class when open
                 aria-labelledby="headingThree"
                 data-bs-parent="#accordionExample"
               >
                 <div className="accordion-body" style={{height: '400px', overflowY: 'auto'}}>
                   {/* Instructions Content */}
                   <h5 style={{fontSize: 15 }}><b>1. Webcam & Consent:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Keep your webcam ON during the test for integrity.
                     </li>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 18, color: "#00a7ac", marginRight: 10 }}></i>
                       Your video (image & audio) will be recorded for assessment purposes.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>2. Data Privacy</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Videos are securely stored and will be deleted once the job post is closed.
                     </li>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Used only for evaluating your test performance at KnackHire.
                     </li>
                   </ul>
 
                   <h5 style={{ fontSize: 15 }}><b>3. Submission Rules:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       One attempt only – ensure all answers are completed before submitting.
                     </li>
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                     Your score will be based on that recorded answer only.
                     </li>
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       If you want the AI to read the question aloud, click on the <b>Read Question</b> button.
                     </li>
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       To move to the next question, click on the <b>Next Question</b> button.
                     </li>
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Click "Submit" to successfully complete the test.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>4. Malpractice Policy:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Any malpractice (tab switching, googling, copy-pasting) will lead to automatic submission.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>5. Test Timing:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Timer starts once you begin. Test auto-submits when time ends.
                     </li>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Do not close the window until you see confirmation of video submission.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>6. Device Usage:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Use only your device’s built-in webcam, microphone & keyboard. No external devices.
                     </li>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       No earphones/earbuds allowed.
                     </li>
                   </ul>
 
                   {/* <h5 style={{fontSize: 15 }}><b>7. Introduction Requirement:</b></h5> */}
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       <b>  📌 Before starting, Please Follow these guidelines to ensure a smooth assessment process. Good luck! 🚀</b>
                     </li>
                   </ul>
 
                   {/* Consent Checkbox */}
                   <div className="form-check mt-3 ml-3">
  <input 
    className="form-check-input" 
    type="checkbox" 
    id="consentCheckbox" 
    checked={isChecked} 
    onChange={handleCheckboxChange} 
  />
  <label className="form-check-label" htmlFor="consentCheckbox" style={{ fontSize: 15, color: "red" }}>
  I have read and understood the instructions.
  </label>
</div>

                 </div>
               </div>
             </div>
           </div>
        
 
 
   
             {!showQuestions &&
             <button
             onClick={startTest}
             className="btn btn-primary mt-3 mb-3"
             style={{
             backgroundColor: "#00a7ac",
             border: "none",
             borderRadius: 15,
             }}
             >
             Start Test
             </button>
             }
 </div>
     
 
     <div className={`col-sm-12 col-lg-${isExpanded ? 12 : 6} col-xl-${isExpanded ? 12 : 6} col-md-${isExpanded ? 12 : 6}`}>
       <div class="row">
      <div className="col-sm-12 col-lg-8 col-xl-8 col-md-8">
 {interviewComplete ? (
  <div>
    {/* Display something after interview completion */}
  </div>
) : (
  showQuestions && (
    <div>
       <p>
   <strong style={{ color: "#00a7ac" }}>Question {currentQuestionIndex + 1} of {questions.length}:</strong>
   <span className="text-paraa" style={{ fontSize: 18 }}>
     {/* {questions[currentQuestionIndex]} */}
      {parse(DOMPurify.sanitize(questions[currentQuestionIndex]))}
   </span> 
 </p>
       
    </div>
  )
)}

</div>

        <div class="col-sm-12 col-lg-4 col-xl-4 col-md-12">
        <div className="d-flex">
<div>

</div>
 
  <div>
     {showQuestions && !interviewComplete && currentQuestionIndex < questions.length - 1 && (
  <button
    className="btn btn-primary mb-3 "
    style={{
      backgroundColor: "#00a7ac",
      border: "none",
      borderRadius: 15,
      width: '140px',
marginRight:'11px'
    }}
    onClick={handleNextQuestion}
  >
   <i className="fa fa-arrow-right" aria-hidden="true" style={{ color: "#fff", backgroundColor: "#00a7ac" }}></i>  Next Question
  </button>
)}
 {showQuestions && currentQuestionIndex === questions.length - 1 && (
  <button
    onClick={stopRecording}
    disabled={!cameraStarted}
    className="btn btn-success mb-3"
    style={{
      backgroundColor: "green",
      border: "none",
      borderRadius: 15,
      width: '140px',
      height:'38px',
      marginRight:'11px' 
    }}> 
  
    Submit
  </button>
)}            
  </div>
  <div>
    <button
    className="btn btn-primary mb-3"
    style={{
      backgroundColor: "#00a7ac",
      border: "none",
      borderRadius: 15,
      width: '140px',
    }}>
      Time : <b>{formatTime(timeRemaining)}</b>
   </button>
  </div>
{/* {showQuestions &&  <div>
    <p 
      className="text-para" 
      style={{ 
        fontSize: 30,
        color: '#00a7ac',
        
      }}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <i className="fa fa-expand"></i> {/* Font Awesome expand icon */}
    {/* </p>
  </div>
} */} 
</div>
        </div>
      
  

           {interviewComplete ? (
             <div>
             
             </div>
             ) : showQuestions && (
              
<div>
   
 
    
{/*               
                <p className="mt-3">
                 <strong style={{ color: "#00a7ac" }}>Your Answer:</strong> 
                 <span className="text-paraa" style={{ fontSize: 18 }}>
                   {tempAnswer || candidateResponses[currentQuestionIndex] || "No Answer Yet"}
                 </span>
               </p> 
              
               <br /> */}
</div> 
             
             ) } 
           
           </div>
  {/* {showQuestions && !interviewComplete &&    <>
            
  <div className="" 
  style={{ position: 'absolute', left: '0', right: '0', transform: 'translateY(-50%)', width: '100%' }}>
    
    {/* Left Button */}
    {/* <div>
    <button
  className="btn btn-primary"
  style={{
    width: "180px",
    backgroundColor: "#00a7ac",
    border: "none",
    borderRadius: 15,
    marginBottom:'20px',
    float:"right",
    marginRight:'30px'
  }}
  onClick={() => speakQuestion(questions[currentQuestionIndex])}
>
  {isSpeaking ? "⏹ Stop Reading" : "🔊 Read Question"}
</button>
    </div> */}

    {/* Right Button */}
 <div className="row">                      
{showVideo && (
<div
  className=""
  style={{
    border: 'none',
    height: '500px', // adjust as needed
   
    width:'700px',
    margin:'auto'
  }}
>
   <div className="row">
   
  {/* <div className="col-sm-12 col-lg-12 col-xl-12 col-md-12">
  {data.isVideoRequired ? (
    <>
      <video
        ref={webcamVideoRef}
        autoPlay
        muted
        className="w-100 h-100"
        style={{ objectFit: 'cover' }} // keeps aspect ratio while filling the container
      />
      {videoUrl && (
        <video
          src={videoUrl}
          controls
          className="w-100"
          style={{ height: '150px', objectFit: 'cover' }} // adjust height as needed
        />
      )}
    </>
  ) : (
    <img
      src={ailogo}
      alt="AI Logo"
      className="w-100 h-100"
      style={{ objectFit: 'contain' }} // or 'cover' depending on the desired fit
    />
  )}
  </div> */}
     

    {data.isVideoRequired ? (
      <>
        <video ref={webcamVideoRef} autoPlay muted   className="w-100 h-100"
        style={{ objectFit: 'cover' }}  />
        {videoUrl && (
          <video src={videoUrl} controls   className="w-100"
          style={{ height: '150px', objectFit: 'cover' }} />
        )}
      </>
    ) : (
      <img src={ailogo} alt="AI Logo" className="w-100 h-100" />
    )}
   
  </div>
</div>

)}
</div>
        
 
      
     </div>

     </div>
     
 {showInstructions && (
       <div>
          
       </div>
  )}
     
    
 </div>
 </div>
              
           )}
         </div>
       ) : (
         <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
           <div className="container" style={{ textAlign: "center" }}>
             <h4>You have already attempted the interview, please reach out to <b style={{ color: "#00a7ac" }}>hire@knackhook.com</b> if you have any questions.</h4>
           </div>
         </div>
       )}
      
       </NoMobileAccess>
      );
};


export default Assessment;